import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CNRApprovalsHome from './CNRApprovalsHome/CNRApprovalsHome'

const Home = () => (
  <Switch>
    <Route exact path="/aprobaciones-cnr" component={CNRApprovalsHome} />
  </Switch>
)

export default Home 
